import { render, staticRenderFns } from "./TrainingCoursesTabEnrolmentsAddNew.vue?vue&type=template&id=67a161be&"
import script from "./TrainingCoursesTabEnrolmentsAddNew.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesTabEnrolmentsAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports